import { MobileWrapperState } from 'modules/homescreen/hoc/mobileWrapper';
import React, { PureComponent } from 'react';
import FormatUtils from 'utils/FormatUtils';
import { Filter } from 'model/Filters';
import FilterTrigger from './FilterTrigger';
import PeoplePopover from 'modules/common/Popovers/PeoplePopover';
import { analyticsTrack } from 'utils/analytics';

interface PeoplePopoverTriggerProps extends Partial<MobileWrapperState> {
  adultsFilter: Filter;
  childrenFilter: Filter;
}

interface PeoplePopoverTriggerState {
  show: boolean;
}

class PeoplePopoverTrigger extends PureComponent<PeoplePopoverTriggerProps, PeoplePopoverTriggerState> {
  state = {
    show: false,
  };

  togglePopover = () => {
    if (!this.state.show) {
      const filterCategory = 'people';
      analyticsTrack(
        { type: 'click', subject: `open filter`, value: { filterCategory }, valueString: filterCategory },
        { category: 'Search page', action: 'click', label: 'Filter guests' }
      );
    }

    this.setState({ show: !this.state.show });
  };

  closePopover = ({ callback }: {  callback?: () => void }) => {
    this.setState({ show: false }, callback);
  };

  renderPopover() {
    if (this.state.show) {
      return (
        <PeoplePopover
          onClose={this.closePopover}
        />
      );
    }

    return null;
  }

  render() {
    const { adultsFilter, childrenFilter, isMobile } = this.props;

    return (
      <div>
        <FilterTrigger
          isMobile={isMobile}
          destination="/filter/guests/"
          text={FormatUtils.getPeopleText(adultsFilter.value, childrenFilter.value)}
          togglePopover={this.togglePopover}
          isActive={true}
        />
        {this.renderPopover()}
      </div>
    );
  }
}

export default PeoplePopoverTrigger;
